// extracted by css-extract-rspack-plugin
export default {"VerifyCodeModal-prompt":"sputnik__VerifyCodeModal-prompt__SWtsq","verifyCodeModalPrompt":"sputnik__VerifyCodeModal-prompt__SWtsq"};